import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PdaEditComponent } from './pda-edit.component';

const routes: Routes = [
  {
    path: '',
    component: PdaEditComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PdaEditRoutingModule {}
